(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\main.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _svgInjector = require('./modules/svgInjector');

var _parallax = require('./modules/parallax');

var _imagePopUp = require('./modules/imagePopUp');

var _carousels = require('./modules/carousels');

var _miniGallery = require('./modules/miniGallery');

var _cookies = require('./modules/cookies');

var _scrollTo = require('./modules/scrollTo');

var _googleMaps = require('./modules/googleMaps');

var _video = require('./modules/video');

var _validator = require('./modules/validator');

var _sidePanel = require('./modules/sidePanel');

var _savings = require('./modules/savings');

var _phone = require('./modules/phone');

var _visible = require('./modules/visible');

var _more = require('./modules/more');

var _tracking = require('./modules/tracking');

require('./modules/consultantMap');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import {Load}             from './modules/load';

var svgInjector = new _svgInjector.SvgInjector();
var parallax = new _parallax.Parallax();
var imagePopUp = new _imagePopUp.ImagePopUp();
var carousels = new _carousels.Carousels();
var miniGallery = new _miniGallery.MiniGallery();
var cookies = new _cookies.Cookies();
var scrollTo = new _scrollTo.ScrollTo();
var googleMaps = new _googleMaps.GoogleMaps();
var video = new _video.Video();
var validator = new _validator.Validator();
var sidePanel = new _sidePanel.SidePanel();
var savings = new _savings.Savings();
var phone = new _phone.Phone();
var visible = new _visible.Visible();
var more = new _more.More();
var tracking = new _tracking.Tracking();
// var load              = new Load();

var Main = function () {
    function Main(node_env) {
        _classCallCheck(this, Main);

        this.node_env = node_env;
        this.sections = $('.cms-section');
    }

    _createClass(Main, [{
        key: 'bootstrap',
        value: function bootstrap(callback) {
            var $sections = $(this.sections);
            this.modules($sections);
            this.responsiveModules($sections);
            callback();
        }
    }, {
        key: 'modules',
        value: function modules($sections) {
            parallax.init($sections);
            svgInjector.init();
            imagePopUp.init();
            carousels.init();
            miniGallery.init();
            cookies.init();
            scrollTo.init();
            googleMaps.init();
            video.init();
            validator.init();
            sidePanel.init();
            savings.init();
            phone.init();
            visible.init();
            more.init();
            tracking.init();
            // load.init();
        }
    }, {
        key: 'responsiveModules',
        value: function responsiveModules($sections) {
            $(window).resize(function () {
                parallax.init($sections);
                carousels.init();
                miniGallery.init();
            });

            $(window).scroll(function () {
                $('.video-player').each(function (id, videoPlayer) {
                    if ($(videoPlayer).visible(true)) {
                        video.play($(videoPlayer));
                    } else {
                        video.stop($(videoPlayer));
                    }
                });
            });
        }
    }]);

    return Main;
}();

$(window).load(function () {
    var main = new Main('development');
    main.bootstrap(function () {
        $('#page-overlay').fadeOut(800);
    });
});

},{"./modules/carousels":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\carousels.js","./modules/consultantMap":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\consultantMap.js","./modules/cookies":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\cookies.js","./modules/googleMaps":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\googleMaps.js","./modules/imagePopUp":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\imagePopUp.js","./modules/miniGallery":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\miniGallery.js","./modules/more":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\more.js","./modules/parallax":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\parallax.js","./modules/phone":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\phone.js","./modules/savings":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\savings.js","./modules/scrollTo":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\scrollTo.js","./modules/sidePanel":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\sidePanel.js","./modules/svgInjector":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\svgInjector.js","./modules/tracking":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\tracking.js","./modules/validator":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\validator.js","./modules/video":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\video.js","./modules/visible":"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\visible.js"}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\carousels.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Carousels = exports.Carousels = function () {
    function Carousels() {
        _classCallCheck(this, Carousels);
    }

    _createClass(Carousels, [{
        key: 'init',
        value: function init() {
            var carouselThumbs = $('.gallery-thumbs .owl-carousel, .article-list__slider .owl-carousel, .slider .owl-carousel'),
                carouselZoom = $('.gallery-category--zoom-slider .owl-carousel'),
                pluginFlag = carouselThumbs.length || carouselZoom.length;

            if (pluginFlag) if (carouselThumbs) this.carouselThumbs(carouselThumbs);
            if (carouselZoom) this.carouselZoom(carouselZoom);
        }
    }, {
        key: 'carouselThumbs',
        value: function carouselThumbs(carousel) {
            carousel.owlCarousel({
                items: 1,
                loop: true,
                margin: 0,
                nav: true,
                navText: ['<i class="fa fa-arrow-circle-o-left"></i>', '<i class="fa fa-arrow-circle-o-right"></i>'],
                dots: false,
                thumbs: true,
                autoplay: typeof carousel.data('autoplay') !== 'undefined' ? carousel.data('autoplay') : false,
                thumbsPrerendered: true,
                onChanged: function onChanged(e) {
                    var itemsLength = this._items.length;

                    var $slider = this.$element.closest('.slider'),
                        $slides = $slider.find('.owl-carousel .owl-item:not(.cloned)'),
                        $thumbsContainer = $slider.find('.slider-thumbs'),
                        $thumbsList = $slider.find('.owl-thumbs');

                    var thumbWidth = $thumbsList.find('.owl-thumb-item').outerWidth(true),
                        thumbsListWidth = thumbWidth * itemsLength,
                        thumbsContainerWidth = $thumbsContainer.width();

                    var thumbsOuterWidth = thumbsListWidth - thumbsContainerWidth,
                        thumbsPositionPart = thumbsOuterWidth / itemsLength;

                    var currentPosition = $thumbsList.find('.owl-thumb-item.active').index(),
                        currentSlide = $slides.eq(currentPosition);

                    var firstMarginLeft = parseInt($thumbsList.find('.owl-thumb-item').first().css('margin-left')),
                        lastMarginRight = parseInt($thumbsList.find('.owl-thumb-item').last().css('margin-right'));

                    var offset = currentPosition === 0 ? -firstMarginLeft : currentPosition === itemsLength - 1 ? thumbsContainerWidth - thumbsListWidth + lastMarginRight : (-currentPosition + 1) * thumbsPositionPart - firstMarginLeft;

                    if (thumbsOuterWidth <= 0) {
                        $thumbsList.css({
                            '-webkit-transform': 'translateX(' + -firstMarginLeft + 'px)',
                            '-mox-transform': 'translateX(' + -firstMarginLeft + 'px)',
                            'transform': 'translateX(' + -firstMarginLeft + 'px)'
                        });
                    } else if (thumbsOuterWidth > 0) {
                        $thumbsList.css({
                            '-webkit-transform': 'translateX(' + offset + 'px)',
                            '-mox-transform': 'translateX(' + offset + 'px)',
                            'transform': 'translateX(' + offset + 'px)'
                        });
                    }

                    setTimeout(function () {
                        currentSlide.addClass('active');
                    });
                }
            });
        }
    }, {
        key: 'carouselZoom',
        value: function carouselZoom(carousel) {
            carousel.owlCarousel({
                stagePadding: 40,
                loop: true,
                autoWidth: false,
                center: true,
                margin: 0,
                responsive: {
                    0: {
                        items: 3,
                        autoWidth: true
                    },
                    320: {
                        items: 3
                    },
                    641: {
                        items: 3,
                        autoWidth: true,
                        center: false
                    },
                    1024: {
                        items: 4,
                        center: true,
                        autoWidth: true
                    },
                    1350: {
                        items: 7,
                        center: true,
                        autoWidth: true
                    }
                }
            });

            carousel.find('.owl-item').on('click', function () {
                var $this = $(this),
                    index = $this.index(),
                    itemsLength = $this.siblings('.owl-item').length,
                    itemsHandler = $this.closest('.owl-stage-outer'),
                    activeItems = $this.closest('.gallery-category--zoom-slider').find('.active');

                if ($this.hasClass('zoomed')) {
                    $this.removeClass('zoomed');
                } else if ($this.prev().hasClass('active') && $this.next().hasClass('active') || !$this.prev().hasClass('active') && !$this.next().hasClass('active')) {
                    $('.zoomed').removeClass('zoomed');
                    $this.addClass('zoomed');
                } else if ($this.prev().hasClass('active') && !$this.next().hasClass('active')) {
                    carousel.trigger('next.owl.carousel', [500]);
                    $('.zoomed').removeClass('zoomed');
                    $this.addClass('zoomed');
                } else if (!$this.prev().hasClass('active') && $this.next().hasClass('active')) {
                    carousel.trigger('prev.owl.carousel', [500]);
                    $('.zoomed').removeClass('zoomed');
                    $this.addClass('zoomed');
                }
            });
        }
    }]);

    return Carousels;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\consultantMap.js":[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function ($) {
    var __selCounty = '[id^="county-"]',
        __selVoivodeship = 'g[id^="voivodeship-"]',
        __selSpecialization = '.features-list--specialization [data-category]',
        __selContainer = '[data-container="consultant"]',
        __selTemplate = '[data-template="consultant"]',
        __selAvatar = '.consultant__avatar',
        __selName = '.consultant__name',
        __selEmail = '.consultant__email',
        __selPhoneStart = '.consultant__phone .phone-start',
        __selPhoneEnd = '.consultant__phone .phone-button',
        __selQrCode = '.qr img',
        __clsSpecializationSelected = 'active',
        __clsMapObjectSelected = 'selected',
        __clsObjectDisabled = 'disabled',
        __clsMapZoomed = 'zoomed',
        __regexPhoneStart = /(\s|\-){1}[\s\S]+/g,
        __regexPhoneEnd = /([\S]{3}[\s]{0,1}){1}/g,
        __zoomFactor = 3,
        __searchParams = {},
        buttonZoomOut = $('.button-zoomout'),
        $map,
        fnInit = function fnInit() {
        return fnBootstrapMapObject(this), fnRegisterTriggers(this), fnBootstrapSelf(this);
    },
        fnBootstrapMapObject = function fnBootstrapMapObject($context) {
        $map = $context;

        $map.isZoomed = false;
        $map.zoomFactor = __zoomFactor;
        $map.SVG = $context.get(0);
        $map.plane = {
            height: $map.SVG.getBBox().height,
            width: $map.SVG.getBBox().width,
            centerX: $map.SVG.getBBox().width / 2,
            centerY: $map.SVG.getBBox().height / 2,
            displayScale: $map.width() / $map.SVG.getBBox().width
        };
        $map.selectedCounty = null;
        $map.selectedVoivodeship = null;
        $map.selectedSpecialization = null;

        $map.zoomOut = objFnZoomOut;
        $map.zoomIn = objFnZoomIn;
        $map.hasFullData = objFnHasFullData;
        $map.getAjaxData = objFnGetAjaxData;
        $map.currentCounty = objFnCurrentCounty;
        $map.currentVoivodeship = objFnCurrentVoivodeship;
        $map.scaleTransform = objFnScaleTransform, $map.scaleTransformOut = objFnScaleTransformOut;

        $map.find(__selVoivodeship).each(utilFnCalcVoivodeshipData);
    },
        fnRegisterTriggers = function fnRegisterTriggers($context) {
        $(__selSpecialization).on('click specialization:update', handleSpecializationUpdate);

        buttonZoomOut.on('click', function () {
            $map.zoomOut();
        });

        $context.on('click voivodeship:update', __selVoivodeship, handleVoivodeshipUpdate).on('click county:update', __selCounty, handleCountyUpdate);
    },
        fnBootstrapSelf = function fnBootstrapSelf() {
        return utilFnStripQuery(), utilFnSelectSpecialization();
    },
        fnSearch = function fnSearch() {
        return utilFnAjax(window.CMS.routes.consultant_search, $map.getAjaxData(), fnApplySearchResult);
    },
        fnApplySearchResult = function fnApplySearchResult(response) {
        if (response.length === 0) {
            return handleAjaxEmptyResponse(response);
        }

        var $container = $(__selContainer),
            content = null;

        $.each(response, function (k, item) {
            var $template = $($(__selTemplate).html()),
                phoneStart = item.phone.replace(__regexPhoneStart, ''),
                phoneEnd = item.phone.replace(__regexPhoneEnd, '');

            if (phoneStart.length > 3) {
                phoneStart = item.phone.substr(0, 3);
                phoneEnd = item.phone.substr(3);
            }

            typeof item.avatar !== 'undefined' && item.avatar !== null && item.avatar.length > 0 ? $template.find(__selAvatar).css('background-image', 'url(' + item.avatar + ')') : null;

            typeof item.qrcode !== 'undefined' && item.qrcode !== null && item.qrcode.length > 0 ? $template.find(__selQrCode).attr('src', item.qrcode) : $template.find(__selQrCode).addClass('d-none');

            $template.find(__selName).text(item.name);
            $template.find(__selEmail).attr('href', 'mailto:' + item.email).find('span').text(item.email);
            $template.find(__selPhoneStart).text(phoneStart);
            $template.find(__selPhoneEnd).attr('data-number', phoneEnd).attr('data-voivodeship', item.voivodeship).attr('data-county', item.county);

            content = content === null ? $template.get(0).outerHTML : content + $template.get(0).outerHTML;
        });

        $container.animate({ opacity: 0 }, 200, function () {
            $container.html(content).promise().done(function () {
                $container.animate({ opacity: 1 }, 300);
            });
        });
    },
        handleSpecializationUpdate = function handleSpecializationUpdate(event, params) {
        var $this = $(this),
            $new = null,
            newSpecialization = $this.data('category'),
            directive = utilFnExtractDirectives(this, ['skipLevels', 'replaceDefault']);

        var top = $('#localization').offset().top + 140;

        $('html,body').animate({
            scrollTop: top
        }, 750);

        if ($this.hasClass(__clsObjectDisabled) || $map.selectedSpecialization === newSpecialization) {
            return;
        }

        $new = $('[data-category="' + newSpecialization + '"]');

        $('[data-category="' + $map.selectedSpecialization + '"]').removeClass(__clsSpecializationSelected).promise().done(function () {
            $map.selectedSpecialization = newSpecialization;
            $new.addClass(__clsSpecializationSelected);

            if (directive) {
                return utilFnFireDirective(directive);
            }

            return utilFnLockObjects(true), $map.hasFullData() ? fnSearch() : $map.selectedCounty !== null ? null : $map.zoomOut();
        });
    },
        handleVoivodeshipUpdate = function handleVoivodeshipUpdate(event, params) {
        if ($(this).hasClass(__clsObjectDisabled)) {
            return;
        }

        return $map.isZoomed ? $map.zoomOut(this) : $map.zoomIn(this);
    },
        handleCountyUpdate = function handleCountyUpdate(event, params) {
        if ($(this).hasClass(__clsObjectDisabled) || $map.selectedCounty === this.id) {
            return;
        }

        return $map.find('#' + $map.selectedCounty).removeClass(__clsMapObjectSelected), $map.selectedCounty = this.id, $(this).addClass(__clsMapObjectSelected), $map.hasFullData() ? fnSearch() : utilFnLockObjects();
    },
        handleAjaxEmptyResponse = function handleAjaxEmptyResponse(response) {
        try {
            var specParams = $map.selectedSpecialization === null ? [] : $('[data-category="' + $map.selectedSpecialization + '"]').data('js-params'),
                default_response = _typeof(specParams.defaults) === 'object' ? specParams.defaults : window.CMS.pageParams.default_consultants;

            return fnApplySearchResult(default_response);
        } catch (e) {}

        $(__selContainer).animate({ opacity: 0 }, 500, function () {
            $(this).html($(__selTemplate).html()).promise().done(function () {
                $(this).animate({ opacity: 1 }, 500);
            });
        });
    },
        handleAjaxError = function handleAjaxError(response) {
        return handleAjaxEmptyResponse(response);
    },
        objFnHasFullData = function objFnHasFullData() {
        return this.selectedSpecialization !== null && this.selectedVoivodeship !== null && this.selectedCounty !== null;
    },
        objFnGetAjaxData = function objFnGetAjaxData() {
        return {
            specialization: this.selectedSpecialization,
            voivodeship: this.selectedVoivodeship.replace(/[^\d]+/g, ''),
            county: this.selectedCounty.replace(/[^\d]+/g, '')
        };
    },
        objFnZoomIn = function objFnZoomIn(context) {
        if (!this.isZoomed) {
            buttonZoomOut.fadeIn();
            var contextId = context.id,
                check = contextId.indexOf("-slaskie"),
                zoom = check != -1 ? context.zoomFactor * 1.2 : context.zoomFactor;

            return this.scaleTransform(context.scaledCenterX, context.scaledCenterY, context.translateX, context.translateY, zoom), this.addClass(__clsMapZoomed), this.isZoomed = true, this.selectedVoivodeship = context.id, this.currentVoivodeship().addClass(__clsMapObjectSelected), utilFnLockObjects();
        }
    },
        objFnZoomOut = function objFnZoomOut(context) {
        var forceScan = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        buttonZoomOut.fadeOut();

        return this.scaleTransformOut(), this.currentVoivodeship().removeClass(__clsMapObjectSelected), this.currentCounty().removeClass(__clsMapObjectSelected), this.selectedVoivodeship = null, this.selectedCounty = null, this.removeClass(__clsMapZoomed), this.isZoomed = false, utilFnLockObjects(forceScan);
    },
        objFnCurrentVoivodeship = function objFnCurrentVoivodeship() {
        return this.selectedVoivodeship === null ? $(null) : this.find('g[id="' + this.selectedVoivodeship.replace('voivodeship', 'v').replace(/-[\d]+/g, '') + '"]');
    },
        objFnCurrentCounty = function objFnCurrentCounty() {
        return this.selectedCounty === null ? $(null) : this.find('#' + this.selectedCounty);
    },
        objFnScaleTransform = function objFnScaleTransform(centerX, centerY, translateX, translateY, zoomFactor) {
        return this.SVG.style.transformOrigin = centerX / this.plane.width * 100 + '% ' + centerY / this.plane.height * 100 + '%', this.SVG.style.transform = 'translate(' + translateX + 'px, ' + translateY + 'px) scale(' + zoomFactor + ')';
    },
        objFnScaleTransformOut = function objFnScaleTransformOut() {
        return this.SVG.style.transform = 'translate(0,0) scale(1)';
    },
        utilFnStripQuery = function utilFnStripQuery(callback) {
        if (window.location.search.length) {
            var searchString = window.location.search.replace(/^\?/, '');

            $.each(searchString.split('&'), function () {
                var split = this.split('='),
                    name = split.shift(0, 1);

                if (typeof __searchParams[name] !== 'undefined' && __searchParams[name] !== null) {
                    __searchParams[name] = typeof __searchParams[name] === 'string' ? [__searchParams[name]].concat(split) : __searchParams[name].concat(split);
                } else {
                    __searchParams[name] = split;
                }
            });
        }

        if (typeof callback === 'function') {
            callback();
        }
    },
        utilFnSelectSpecialization = function utilFnSelectSpecialization() {
        var specializations = typeof __searchParams.specialization === 'undefined' || __searchParams.specialization === null ? null : __searchParams.specialization;

        if (specializations === null) {
            return utilFnLockObjects();
        }

        $.proxy(handleSpecializationUpdate, $(__selSpecialization.replace(']', '="' + specializations + '"]')).get(0))();
    },
        utilFnLockObjects = function utilFnLockObjects() {
        var forceScan = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if ($map.hasFullData() && !forceScan) {
            return;
        } else if ($map.selectedSpecialization === null || $map.selectedVoivodeship === null) {
            return handleAjaxEmptyResponse(), utilFnAjax(window.CMS.routes.empty_voivodeships, { specialization: $map.selectedSpecialization }, utilFnToggleVoivodeshipsLock);
        } else {
            utilFnAjax(window.CMS.routes.empty_counties, {
                specialization: $map.selectedSpecialization,
                voivodeship: $map.selectedVoivodeship.replace(/[^\d]+/g, '')
            }, utilFnToggleCountiesLock);
        }
    },
        utilFnToggleVoivodeshipsLock = function utilFnToggleVoivodeshipsLock(response) {
        $(__selVoivodeship).each(function () {
            response.indexOf(parseInt(this.id.replace(/[^\d]+/g, ''))) === -1 ? $(this).removeClass(__clsObjectDisabled) : $(this).addClass(__clsObjectDisabled);
        });
    },
        utilFnToggleCountiesLock = function utilFnToggleCountiesLock(response) {
        var selector = $map.selectedVoivodeship !== null && $map.selectedVoivodeship.length > 0 ? 'g[id="' + $map.selectedVoivodeship.replace('voivodeship', 'v').replace(/-[\d]+/g, '') + '"]' : 'g[id^="voivodeship-"]';

        $map.find(selector).find(__selCounty).each(function () {
            response.indexOf(parseInt(this.id.replace(/[^\d]+/g, ''))) === -1 ? $(this).removeClass(__clsObjectDisabled) : $(this).addClass(__clsObjectDisabled);

            if (this.id === $map.selectedCounty && $map.currentCounty().hasClass(__clsObjectDisabled)) {
                $map.zoomOut();
                return false;
            }
        });
    },
        utilFnAjax = function utilFnAjax(url, data, callback) {
        $.ajax({
            method: 'post',
            url: url,
            data: data,
            success: callback,
            error: handleAjaxError
        });
    },
        utilFnCalcVoivodeshipData = function utilFnCalcVoivodeshipData() {
        this.width = this.getBBox().width;
        this.height = this.getBBox().height;
        this.offsetX = this.getBBox().x;
        this.offsetY = this.getBBox().y;
        this.centerX = this.offsetX + this.width / 2;
        this.centerY = this.offsetY + this.height / 2;
        this.scaledCenterX = this.centerX * $map.plane.displayScale;
        this.scaledCenterY = this.centerY * $map.plane.displayScale;
        this.translateX = ($map.plane.centerX - this.centerX) * $map.plane.displayScale;
        this.translateY = ($map.plane.centerY - this.centerY) * $map.plane.displayScale;

        var maxZoomX = $map.plane.width / this.width,
            maxZoomY = $map.plane.height / this.height,
            zoomX = maxZoomX <= $map.zoomFactor ? maxZoomX : $map.zoomFactor,
            zoomY = maxZoomY <= $map.zoomFactor ? maxZoomY : $map.zoomFactor;

        this.zoomFactor = zoomX <= zoomY ? zoomX : zoomY;
    },
        utilFnExtractDirectives = function utilFnExtractDirectives(object, allowed) {
        try {
            if (typeof object.dataset.jsParams !== 'string' || object.dataset.jsParams.length === 0) {
                return false;
            }

            var directive = JSON.parse(object.dataset.jsParams);

            return allowed.indexOf(directive.directive) !== -1 ? directive : false;
        } catch (e) {
            console.log(e);
            return false;
        }
    },
        utilFnFireDirective = function utilFnFireDirective(_ref) {
        var directive = _ref.directive,
            data = _ref.data;

        if (directive === 'skipLevels') {
            if ($map.isZoomed) {
                $map.scaleTransformOut();
                $map.currentVoivodeship().removeClass(__clsMapObjectSelected);
                $map.currentCounty().removeClass(__clsMapObjectSelected);
                $map.isZoomed = false;
                $map.selectedVoivodeship = null;
                $map.selectedCounty = null;
                $map.removeClass(__clsMapZoomed);
            }
            return utilFnLockObjects(), fnApplySearchResult(Array.isArray(data) ? data : [data]);
        }
    };

    $.fn.consultantMap = function () {
        $.proxy(fnInit, this)();

        return this;
    };
})(jQuery);

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\cookies.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = exports.Cookies = function () {
    function Cookies() {
        _classCallCheck(this, Cookies);
    }

    _createClass(Cookies, [{
        key: 'init',
        value: function init() {
            var self = this;
            $(document).ready(function () {
                if (self.getCookie('cookie_agree') != 1) {
                    $('.cookies-tab').css({ opacity: 0 }).removeClass('d-none').animate({ opacity: 1 }, 500);
                    $('.cookies-tab .button').click(function () {
                        self.cookieAgree();
                        return false;
                    });
                }
            });
        }
    }, {
        key: 'cookieAgree',
        value: function cookieAgree() {
            var self = this;
            self.setCookie("cookie_agree", 1, 365);
            $('.cookies-tab').fadeOut(400);
        }
    }, {
        key: 'getCookie',
        value: function getCookie(name) {
            var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return v ? v[2] : null;
        }
    }, {
        key: 'setCookie',
        value: function setCookie(name, value, days) {
            var d = new Date();
            d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
            document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
        }
    }]);

    return Cookies;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\googleMaps.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMaps = exports.GoogleMaps = function () {
	function GoogleMaps() {
		_classCallCheck(this, GoogleMaps);
	}

	_createClass(GoogleMaps, [{
		key: 'init',
		value: function init() {
			var self = this;
			if ($('.google-map').length) {
				$(document).ready(function () {
					self.geocode();
				});
			}
		}
	}, {
		key: 'geocode',
		value: function geocode() {
			$('.google-map').each(function (id, mapSection) {
				var address = $(mapSection).data('address'),
				    mapContent = $(mapSection).find('.google-map__content').attr('id');
				var mapOptions = {
					zoom: 15,
					center: new google.maps.LatLng(40.6700, -73.9400),
					styles: [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }]
				};

				var mapElement = document.getElementById(mapContent);

				var map = new google.maps.Map(mapElement, mapOptions);
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'address': address }, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						map.setCenter(results[0].geometry.location);
						var marker = new google.maps.Marker({
							map: map,
							position: results[0].geometry.location
						});
					}
				});
			});
		}
	}]);

	return GoogleMaps;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\imagePopUp.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImagePopUp = exports.ImagePopUp = function () {
    function ImagePopUp() {
        _classCallCheck(this, ImagePopUp);
    }

    _createClass(ImagePopUp, [{
        key: 'init',
        value: function init() {
            $('.picture a, .image a').magnificPopup({
                type: 'image',
                closeOnContentClick: true,
                closeBtnInside: false,
                fixedContentPos: true,
                mainClass: 'mfp-no-margins mfp-with-zoom',
                image: {
                    verticalFit: true
                },
                zoom: {
                    enabled: true,
                    duration: 300
                }
            });
        }
    }]);

    return ImagePopUp;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\miniGallery.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MiniGallery = exports.MiniGallery = function () {
    function MiniGallery() {
        _classCallCheck(this, MiniGallery);
    }

    _createClass(MiniGallery, [{
        key: 'init',
        value: function init() {
            var miniGalleryLength = $('.gallery').length,
                noGridGalleryLength = $('.js-no-grid').length;

            if (miniGalleryLength) {
                for (var i = miniGalleryLength; i--;) {
                    $('.gallery').eq(i).magnificPopup({
                        delegate: 'a',
                        type: 'image',
                        closeOnContentClick: true,
                        closeBtnInside: false,
                        fixedContentPos: true,
                        mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
                        image: {
                            verticalFit: true
                        },
                        tLoading: 'Ładuję...',
                        gallery: {
                            enabled: true,
                            tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
                        },
                        zoom: {
                            enabled: false,
                            duration: 300 // don't foget to change the duration also in CSS
                        }
                    });
                }
            }
        }
    }]);

    return MiniGallery;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\more.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var More = exports.More = function () {
	function More() {
		_classCallCheck(this, More);
	}

	_createClass(More, [{
		key: 'init',
		value: function init() {
			$('.more-text a').click(function (e) {
				e.preventDefault();
				$(this).closest('.ex-text').siblings('.ex-text').slideDown();
			});
		}
	}]);

	return More;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\parallax.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Parallax = exports.Parallax = function () {
    function Parallax() {
        _classCallCheck(this, Parallax);
    }

    _createClass(Parallax, [{
        key: 'init',
        value: function init($sections) {
            if ($(window).width() > 1020) {
                $(window).scroll(function () {
                    var wScrollTop = $(window).scrollTop();
                    $('[data-parallax="true"]').each(function (id, item) {
                        if ($(this).visible(true)) {
                            var itemTop = $(this).offset().top;
                            var s = wScrollTop - itemTop;
                            $(this).find('.parallax-bg').css({
                                'transform': 'translateY(' + s * 0.3 + 'px)',
                                '-webkit-transform': 'translateY(' + s * 0.3 + 'px)',
                                '-moz-transform': 'translateY(' + s * 0.3 + 'px)'
                            });
                        }
                    });
                });
            }
        }
    }]);

    return Parallax;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\phone.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Phone = exports.Phone = function () {
	function Phone() {
		_classCallCheck(this, Phone);
	}

	_createClass(Phone, [{
		key: 'init',
		value: function init() {
			$(document).on('click', '.phone-button', function () {
				$(this).html($(this).data('number')).addClass('clicked');

				var $this = $(this),
				    category = $('.features-list--specialization .active span').text(),
				    voivodeship = $this.data('voivodeship'),
				    county = $this.data('count'),
				    number = document.getElementsByClassName('consultant__phone')[0].innerText;

				ga("send", "event", category, voivodeship + ' - ' + county, number);
			});

			$('.btn-advisors').on('click', function () {
				ga("send", "event", "button", "Klik", "znajdź doradcę - top");
			});
			$('.btn-parameters').on('click', function () {
				ga("send", "event", "button", "Klik", "znajdź doradcę - bottom");
			});
		}
	}]);

	return Phone;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\savings.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Savings = exports.Savings = function () {
	function Savings() {
		_classCallCheck(this, Savings);
	}

	_createClass(Savings, [{
		key: 'init',
		value: function init() {
			var self = this;

			$('.savings-slider').jRange({
				from: 0,
				to: 1000,
				step: 10,
				scale: [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
				showLabels: true,
				width: $(window).width() > 992 ? $('.savings-slider').closest('.container').width() * 0.8 : $('.savings-slider').closest('.container').width(),
				onstatechange: function onstatechange() {
					self.savingsMath(this);
				}
			});
			$('#range').keyup(function () {
				var value = this.value,
				    time = $('.savings-time').data('value'),
				    newValue = time * value;

				$('.savings-amount').html(newValue + ' <span class="unit">zł</span>').data('value', newValue);
			});
		}
	}, {
		key: 'savingsMath',
		value: function savingsMath(slider) {
			var counter = 11 / 15,
			    sliderValue = parseInt(slider.highLabel[0].innerText),
			    bottlesBG = Math.floor(sliderValue * counter),
			    hourRate = $('#range').val(),
			    timeSavings = Math.floor((sliderValue - bottlesBG) * 0.25),
			    moneySavings = Math.floor(timeSavings * hourRate);

			$('.bigger-bottles').html(bottlesBG).data('value', bottlesBG);
			$('.savings-amount').html(moneySavings + ' <span class="unit">zł</span>').data('value', moneySavings);
			$('.savings-time').html(timeSavings + ' <span class="unit">godz.</span>').data('value', timeSavings);
		}
	}]);

	return Savings;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\scrollTo.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollTo = exports.ScrollTo = function () {
	function ScrollTo() {
		_classCallCheck(this, ScrollTo);
	}

	_createClass(ScrollTo, [{
		key: 'init',
		value: function init() {
			$('.scroll-to').on('click', function (e) {
				e.preventDefault();
				var distElement = $(this).closest('.section').next('.section').attr('id'),
				    distElementTop = $('#' + distElement).offset().top;

				$('html, body').animate({
					scrollTop: distElementTop
				}, 500);
			});
			$('.features-list--modules a').each(function () {
				$(this).on('click', function (e) {
					e.preventDefault();
					var distElement = $(this).attr('href');
					var distElementTop = $(distElement).offset().top;

					$('html, body').animate({
						scrollTop: distElementTop
					}, 500);
				});
			});
		}
	}]);

	return ScrollTo;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\sidePanel.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SidePanel = exports.SidePanel = function () {
	function SidePanel() {
		_classCallCheck(this, SidePanel);
	}

	_createClass(SidePanel, [{
		key: 'init',
		value: function init() {
			if ((typeof sidePanelOptions === 'undefined' ? 'undefined' : _typeof(sidePanelOptions)) == 'object') {
				var self = this,
				    cookieFlag = self.getCookie('side-panel-' + sidePanelOptions.siteId),
				    currentCookie = cookieFlag != null ? JSON.parse(cookieFlag) : null,
				    body = $('body');

				$(document).ready(function () {
					if (currentCookie == null || currentCookie.id != sidePanelOptions.id) {
						sidePanelOptions.closed = 0;
						self.setCookie('side-panel-' + sidePanelOptions.siteId, JSON.stringify(sidePanelOptions), 365);
						self.checkRevealType();
					} else {
						if (currentCookie.closed == 0 && sidePanelOptions.reactive == 0 || currentCookie.closed == 1 && currentCookie.reactive == 0 && sidePanelOptions.reactive == 1) {
							self.checkRevealType();
						}
					}

					body.on('click', '.side-panel__close', function () {
						self.hidePanel();
					});
					body.on('click', '.side-panel.close', function () {
						self.reopenPanel();
					});
				});
			}
		}
	}, {
		key: 'reopenPanel',
		value: function reopenPanel() {
			$('.side-panel').fadeOut(function () {
				$(this).removeClass('close').addClass('open').fadeIn();
			});
		}
	}, {
		key: 'showPanel',
		value: function showPanel() {
			$('.side-panel').fadeIn(function () {
				$(this).removeClass('close').addClass('open');
			});
		}
	}, {
		key: 'hidePanel',
		value: function hidePanel() {
			var self = this;
			$('.side-panel').fadeOut(function () {
				$(this).removeClass('open').addClass('close').show();
			});
			var cookie = self.getCookie('side-panel-' + sidePanelOptions.siteId);
			var parsedCookie = JSON.parse(cookie);

			parsedCookie.closed = 1;
			sidePanelOptions.reactive == 1 ? parsedCookie.reactive = 1 : parsedCookie.reactive = 0;
			self.setCookie('side-panel-' + sidePanelOptions.siteId, JSON.stringify(parsedCookie), 365);
		}
	}, {
		key: 'showAfterTime',
		value: function showAfterTime(time) {
			var self = this;
			var delay = parseInt(time) * 1000;
			setTimeout(function () {
				self.showPanel();
			}, delay);
		}
	}, {
		key: 'showAfterDistance',
		value: function showAfterDistance(distance) {
			var self = this,
			    notClosed = true;
			$(window).scroll(function () {
				var st = $(window).scrollTop();

				if (st > distance && notClosed) {
					self.showPanel();
					notClosed = false;
				}
			});
		}
	}, {
		key: 'checkRevealType',
		value: function checkRevealType() {
			var self = this;

			if (sidePanelOptions.distance != 0) {
				self.showAfterDistance(sidePanelOptions.distance);
			} else if (sidePanelOptions.time != 0) {
				self.showAfterTime(sidePanelOptions.time);
			}
		}
	}, {
		key: 'getCookie',
		value: function getCookie(name) {
			var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
			return v ? v[2] : null;
		}
	}, {
		key: 'setCookie',
		value: function setCookie(name, value, days) {
			var d = new Date();
			d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
			document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
		}
	}]);

	return SidePanel;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\svgInjector.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SvgInjector = exports.SvgInjector = function () {
    function SvgInjector() {
        _classCallCheck(this, SvgInjector);
    }

    _createClass(SvgInjector, [{
        key: 'init',
        value: function init() {

            var self = this;

            var mySVGsToInject = document.querySelectorAll('img.inject-svg');
            SVGInjector(mySVGsToInject, {}, function () {
                if ($('#map').length != 0) {
                    $('#map').consultantMap();
                }
            });
        }
    }]);

    return SvgInjector;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\tracking.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tracking = exports.Tracking = function () {
    function Tracking() {
        _classCallCheck(this, Tracking);
    }

    _createClass(Tracking, [{
        key: 'init',
        value: function init() {

            $("a.btn-poznaj_zalety").click(function () {
                var event_label = $(this).text();
                ga('send', 'event', 'CTA', 'click', event_label);
            });
        }
    }]);

    return Tracking;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\validator.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validator = exports.Validator = function () {
	function Validator() {
		_classCallCheck(this, Validator);
	}

	_createClass(Validator, [{
		key: 'init',
		value: function init() {
			if ((typeof contactFormRules === 'undefined' ? 'undefined' : _typeof(contactFormRules)) == 'object') {
				$('#contactForm').validate({
					rules: contactFormRules,
					messages: {
						'name': 'Pole jest obowiazkowe',
						'email': {
							required: 'Pole jest obowiązkowe',
							email: 'Wprowadź poprawną wartość'
						},
						'phone': 'Pole jest obowiazkowe',
						'postal-code': 'Pole jest obowiazkowe',
						'checkbox': 'Pole jest obowiazkowe'
					},
					// errorPlacement: function(error, element) { },
					submitHandler: function submitHandler(text) {
						$.ajax({
							url: $('#contactForm').attr("action"),
							method: 'POST',
							data: $('#contactForm').serialize(),
							beforeSend: function beforeSend() {
								$('#contactForm').find('button').prop('disabled', 'disabled');
							},
							success: function success() {
								Monitor.TrackForm('contactForm', 3);
								$('#contactForm').find('input, textarea').val('');
								$('#contactForm').fadeOut(500, function () {
									$('#contactForm').replaceWith('<div class="form__message form__message--success">Wiadomość została wysłana. Dziękujemy.</div>').fadeIn(500);
								});
							},
							error: function error() {
								$('#contactForm').find('input, textarea').val('');
								$('#contactForm').fadeOut(500, function () {
									$('#contactForm').replaceWith('<div class="form__message form__message--error">Wiadomość nie została wysłana. Prosimy spróbować później.</div>').fadeIn(500);
								});
							}
						});
					}
				});
			}
		}
	}]);

	return Validator;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\video.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Video = exports.Video = function () {
	function Video() {
		_classCallCheck(this, Video);
	}

	_createClass(Video, [{
		key: 'init',
		value: function init() {
			var self = this;
			$('.video-player').hover(function (e) {
				e.preventDefault();
				var $this = $(this);
				self.play($this);
			}, function (e) {
				e.preventDefault();
				var $this = $(this);
				self.stop($this);
			});
		}
	}, {
		key: 'play',
		value: function play(video) {
			var videoType = video.data('type');
			if (videoType == 'youtube') {
				video = $(video)[0].contentWindow;
				video.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
			} else if (videoType == 'video') {
				video = video.get(0);
				video.play();
			}
		}
	}, {
		key: 'stop',
		value: function stop(video) {
			var videoType = video.data('type');
			if (videoType == 'youtube') {
				video = $(video)[0].contentWindow;
				video.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			} else if (videoType == 'video') {
				video = video.get(0);
				video.pause();
			}
		}
	}]);

	return Video;
}();

},{}],"C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\modules\\visible.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Visible = exports.Visible = function () {
	function Visible() {
		_classCallCheck(this, Visible);
	}

	_createClass(Visible, [{
		key: 'init',
		value: function init() {
			var elem = $('.container, .container-fluid, .features-list__item, .articles-list__item, .advisors__item');
			var self = this;

			self.checkIfVisible(elem);

			$(window).scroll(function () {
				self.checkIfVisible(elem);
			});
			this.delay($('.article-list--news-homepage .articles-list__item'));
			this.delay($('.features-list--usage .features-list__item'));
			this.delayShort($('.advisors .advisors__item'));
			this.delayShort($('.features-list--offer-homepage .features-list__item'));
			this.delayShort($('.features-list--benefits .features-list__item'));
			this.delayShort($('.features-list--specialization .features-list__item'));
		}
	}, {
		key: 'checkIfVisible',
		value: function checkIfVisible(elem) {
			elem.each(function () {
				var $this = $(this),
				    elemVisible = $this.visible(true, 'vertical');

				if (elemVisible) {
					$this.addClass('on-screen', elemVisible);
					setTimeout(function () {
						$this.addClass('triggered');
					}, 500);
				}
			});
		}
	}, {
		key: 'delay',
		value: function delay(elem) {
			elem.each(function (index) {
				$(this).css('transition-delay', 300 + 150 * index + 'ms');
			});
		}
	}, {
		key: 'delayShort',
		value: function delayShort(elem) {
			elem.each(function (index) {
				$(this).css('transition-delay', 100 * index + 'ms');
			});
		}
	}]);

	return Visible;
}();

},{}]},{},["C:\\xampp\\htdocs\\energia-dla-domu\\www\\resources\\assets\\scripts\\src\\main.js"])

